module.exports = __webpack_public_path__ + "static/media/climbing.b505bbb9.png";